import feathersClient from "../../feathers-client";

const defaultIncentivesReasonPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultIncentiveReasonPaginationFilter = {
	$skip:defaultIncentivesReasonPagination.$skip,
	$limit: defaultIncentivesReasonPagination.$limit
};

export default {
	state:{
		shiftIncentivesReason:[],
		shiftIncentivesReasonPagination:defaultIncentivesReasonPagination,
		shiftIncentivesReasonPaginationFilter:defaultIncentiveReasonPaginationFilter
	},
	getters:{
		setIncentiveReasonPage:(state) => {
			const {$limit, $skip} = state.shiftIncentivesReasonPagination;
			return $skip / $limit + 1;
		},
	},
	mutations:{
		SET_INCENTIVES_REASON:(state,data) => {state.shiftIncentivesReason = data;},
		SET_SHIFT_INCENTIVE_REASON_PAGINATION:(state, data) => {state.shiftIncentivesReasonPagination = {...state.shiftIncentivesReasonPagination, ...data};},
		SET_SHIFT_INCENTIVE_REASON_PAGINATION_FILTER:(state,data) => {state.shiftIncentivesReasonPaginationFilter  = {...state.shiftIncentivesReasonPaginationFilter, ...data};}
	},
	actions:{
		setshiftIncentiveReasonListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.shiftIncentivesReasonPagination.$limit;
			commit('SET_SHIFT_INCENTIVE_REASON_PAGINATION', { $skip });
			commit('SET_SHIFT_INCENTIVE_REASON_PAGINATION_FILTER', { $skip });
		},

		getShiftIncentivesReason: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/shiftincentives-reasons').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter,
				}
			});
			commit('SET_INCENTIVES_REASON',results.data);
			commit('SET_SHIFT_INCENTIVE_REASON_PAGINATION', {total :results.total})
			return results.data;
		},
		createShiftIncentivesReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/shiftincentives-reasons').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateShiftIncentivesReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/shiftincentives-reasons').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteShiftIncentiveReason: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/shiftincentives-reasons').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getShiftIncentiveReasonById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/shiftincentives-reasons').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllShiftIncentivesReasonForTrust: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/shiftincentives-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,
					...filter,

				}
			});
			commit('SET_INCENTIVES_REASON',results.data);
			commit('SET_SHIFT_INCENTIVE_REASON_PAGINATION', {total :results.total})
			return results.data;
		},
		getAllShiftIncentivesReason: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/shiftincentives-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		},

	}
}
